/**
 * Class for particle asset handling.
 * @class ParticleAsset
 * @extends RawAsset
 * @constructor
 */
var ParticleAsset = cc.Class({
    name: 'cc.ParticleAsset',
    extends: cc.RawAsset,
});

cc.ParticleAsset = module.exports = ParticleAsset;
